import { createContext, useContext } from "react";

const AssistProjectTypeContext = createContext(() => {});

const useAssistProjectType = () => useContext(AssistProjectTypeContext);

export { AssistProjectTypeContext, useAssistProjectType };
